const cn = (...args: Array<string | undefined | null | boolean | Record<string, boolean>>): string => {
  const classes: string[] = [];
  
  for (const arg of args) {
    if (!arg) continue;
    
    if (typeof arg === 'string') {
      const trimmed = arg.trim();
      if (trimmed) {
        classes.push(trimmed);
      };
    } else if (typeof arg === 'object') {
      for (const [className, condition] of Object.entries(arg)) {
        if (condition) {
          const trimmed = className.trim();
          if (trimmed) {
            classes.push(trimmed);
          };
        };
      };
    };
  };
  
  return classes.join(' ').trim();
};

export default cn;